const STORAGE_KEY_PREFIX = 'eliminator-roster-ids';

export function rosterStorageKey(season) {
	return `${STORAGE_KEY_PREFIX}:${season}`;
}

export function loadRosterIds(season) {
	if (typeof window === 'undefined') return [];

	try {
		const raw = window.localStorage.getItem(rosterStorageKey(season));
		if (!raw) return [];
		const parsed = JSON.parse(raw);
		if (!Array.isArray(parsed)) return [];
		return parsed.map((id) => Number(id)).filter((id) => Number.isFinite(id));
	} catch (error) {
		return [];
	}
}

export function saveRosterIds(season, ids) {
	if (typeof window === 'undefined') return;

	try {
		window.localStorage.setItem(rosterStorageKey(season), JSON.stringify(ids));
	} catch (error) {
		// Ignore quota / private mode failures.
	}
}
